import 'css-chunksrc/client/pages/zonePage/projectsPage/styles.scss';export default {
  "projects": "_projects_3xz7f_1",
  "main": "_main_3xz7f_9",
  "header": "_header_3xz7f_13",
  "row": "_row_3xz7f_22",
  "scrollingText": "_scrollingText_3xz7f_26",
  "title": "_title_3xz7f_30",
  "contextualMenuIcon": "_contextualMenuIcon_3xz7f_46",
  "wbsConfigurationIcon": "_wbsConfigurationIcon_3xz7f_54",
  "zoneInfo": "_zoneInfo_3xz7f_64",
  "iconBox": "_iconBox_3xz7f_77",
  "avatar": "_avatar_3xz7f_85",
  "name": "_name_3xz7f_93",
  "list": "_list_3xz7f_99",
  "item": "_item_3xz7f_105",
  "folderIcon": "_folderIcon_3xz7f_113",
  "exportButton": "_exportButton_3xz7f_119",
  "content": "_content_3xz7f_126",
  "removeIcon": "_removeIcon_3xz7f_135"
};